<div class="even">
<mat-label class="subHeading ">Vehicle Age<span *ngIf="isRequired" class="star">*</span></mat-label>
<button class="side" (click)="vehicleAgeForm.controls['from'].setValue(null);vehicleAgeForm.controls['to'].setValue(null)">Remove</button>
</div>

<div formGroupName="vehicle_age" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <mat-form-field class="w-50 m-0" appearance="fill">
        <input matInput formControlName="from" placeholder="From Age" type="number" min="0" step="0.1" />
    </mat-form-field>

    <mat-form-field class="w-50 m-0" appearance="fill">
        <input matInput formControlName="to" placeholder="To Age" type="number" min="0" step="0.1"/>
    </mat-form-field>
</div>
